export default __webpack_public_path__ + "static/media/polly-logo-with-text.78b64cb6.svg";